var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('p', [_vm._v("1.对方可以免费领取"), _c('font', {
    staticStyle: {
      "color": "#01ADE7"
    }
  }, [_vm._v("3")]), _vm._v("天VIP；")], 1), _c('p', [_vm._v(" 2.你每邀请1人可以得"), _c('font', {
    staticStyle: {
      "color": "#01ADE7"
    }
  }, [_vm._v("1")]), _vm._v("天VIP，最多得"), _c('font', {
    staticStyle: {
      "color": "#01ADE7"
    }
  }, [_vm._v("90")]), _vm._v("天，邀请人数上不封顶； ")], 1), _c('p', [_vm._v(" 3.你邀请的人开通VIP 你有现金奖励，一级"), _c('font', {
    staticStyle: {
      "color": "#01ADE7"
    }
  }, [_vm._v("30")]), _vm._v("元，二级"), _c('font', {
    staticStyle: {
      "color": "#01ADE7"
    }
  }, [_vm._v("6")]), _vm._v("元 ")], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };